import { ItemStatus } from '../../../../enums/ItemStatus';
import { NodeType } from '../../../../enums/NodeType';
import { Role } from '../../../../enums/Role';
import {
  getInvalidItemDataReference,
  getItemStatusId,
  getSchema
} from '../../../../utils';
import { GetPermissionFn } from '../types';

export const getRemoveItemPermission: GetPermissionFn = ({
  hasRole,
  workspace,
  data
}) => {
  if (hasRole(Role.planningReadonly)) {
    return { canView: false, canEdit: false };
  }

  const statusId = getItemStatusId(data);
  if (![ItemStatus.Not_Pursued, ItemStatus.Idea].includes(statusId)) {
    return { canView: false, canEdit: false };
  }

  const itemSchema = getSchema(workspace.schemas, NodeType.Item);
  if (getInvalidItemDataReference(workspace, itemSchema, data) != null) {
    return { canView: true, canEdit: false };
  }
  return { canView: true, canEdit: true };
};
